import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
//import { Button } from '@mui/material';
import { AppState, DefaultProps } from '../../types/types';
//import  { useState } from 'react';
import IconDigitalePost from '../../assets/images/icon_digitale_post.svg';
import IconDigitalePostRd from '../../assets/images/icon_digitale_post_rd.svg';
//import { ReactComponent as BookmarkIcon} from '../../assets/images/favicon.svg';
import { loadSessionData } from '../../util/store';

//import { addbookmark } from "../../assets/js/bookmark";
//import { CustomerContext } from '../../types/apimodel';
import { CustomerDataContext } from '../context/CustomerDataProvider';

interface GreetingElementProps extends DefaultProps {
    appState: AppState;
    text?: String | null;
}



const GreetingElement: React.FC<GreetingElementProps> = ({ appState,text }) =>{
    const { customer } = useContext(CustomerDataContext);



    const goToKundenakte = () => {
        if (loadSessionData("kundenakteShortUrl")){
            window.location.replace(loadSessionData("kundenakteShortUrl"));
        }
    }    

    const styles = {
        imageSmall: {
          cursor: 'pointer', // Cursor zur Hand ändern
          width: { xs: '120px', sm: '150px', md: '250px', lg: '250px' }, 
          marginLeft: '1rem',
        },
        imageLarge: {
            cursor: 'pointer', // Cursor zur Hand ändern
            width: { xs: '120px', sm: '150px', md: '250px', lg: '250px' }, 
            marginLeft: '1rem', 
           
        }
      };
      
    return (
        <Container maxWidth="lg" >
            <Grid container spacing={0} className="container" sx={{ marginTop: { xs: '1rem', sm: '1rem', md: '3rem', lg: '3rem' } }}>
                <Grid item xs={12} md={6} sm={12} lg={6} sx={{ display: 'flex', justifyContent: 'left', flexDirection: 'column' }}>
                    <Typography variant='h1' sx={{ fontSize: { xs: '1.3rem', sm: '1.3rem', md: '2rem', lg: '2rem' } }}>Guten Tag {customer?.firstname != null ? customer?.firstname : ""} {customer?.lastname != null ? customer?.lastname : ""}, </Typography>
                    <p>
                        {text}
                    </p>
                </Grid>
                <Grid item xs={12} md={6} sm={12} lg={6} sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex' }, justifyContent: { xs: 'center', md: 'right', sm: 'center', lg: 'right' }, textAlign: 'right', alignItems: 'center',paddingRight: "24px"}}>
                    {appState.customizingId === 'rd' &&
                        <Box component="img" sx={styles.imageLarge} alt="Postfach" onClick={goToKundenakte} src={IconDigitalePostRd}></Box>}
                    {appState.customizingId === 'rl' &&
                        <Box component="img" sx={styles.imageLarge} alt="Postfach" onClick={goToKundenakte} src={IconDigitalePost}></Box>}
                </Grid>

                <Grid item xs={12} sm={12} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none' }, justifyContent: { xs: 'center', md: 'right', sm: 'center', lg: 'right' }, textAlign: 'right', alignItems: 'center' }}>
                    {appState.customizingId === 'rd' &&
                        <Box component="img" sx={styles.imageSmall} alt="Postfach" onClick={goToKundenakte} src={IconDigitalePostRd}></Box>}
                    {appState.customizingId === 'rl' &&
                        <Box component="img" sx={styles.imageSmall} alt="Postfach" onClick={goToKundenakte} src={IconDigitalePost}></Box>}
                </Grid>
            </Grid>
        </Container>


    );
}

export default GreetingElement;